import { action } from 'typesafe-actions';
import { MenuTypes } from './types';

export const toggleMenu = () => action(MenuTypes.TOGGLE);
